import "./DataAnalytics.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Achievements from "./sections/Achievements";
import Analytics from "./sections/Analytics";
import Insight from "./sections/Insight";
import Rationale from "./sections/Rationale";
import Trial from "./sections/Trial";
import Footer from "@/reusable_sections/Footer";
export default function DataAnalyticsPage() {
  return <div>
      <Header />
      <Hero />
      <Achievements />
      <Analytics />
      <Insight />
      <Rationale />
      <Trial />
      <Footer />
    </div>;
}